import $ from 'jquery';

$('.product-detail__layout').position_callback({
  offsetTop: -$('.product-detail__layout .section-action').height(),
  topUp() {
    $('.product-fixed-bar').addClass('show');
  },
  topDown() {
    $('.product-fixed-bar').removeClass('show');
  },
});
